import { css, mergeStyleSets, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import React from 'react'
import { useTranslation } from "react-i18next";

function StatusItem(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_StatusItem = props.status;
    const inputParam_Index = props.index;
    const inputParam_StatusId = props.statusId;
    const inputParam_StatusKeyField = props.statusKeyField;
    const inputParam_StatusValueField = props.statusValueField;
    const inputParam_ShowLabel = props.showLabel !== null && props.showLabel !== undefined ? props.showLabel : true;
    const inputParam_RelatedConceptComplete = props.relatedConceptComplete !== null && props.relatedConceptComplete !== undefined ? props.relatedConceptComplete : true;
    
    //Parametros de componente.
    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
        },
    });

    //Funciones de componente.

    //Eventos de componente.

    //Render de componente.
    return (
        <li
            key={inputParam_Index}
            data-step={inputParam_Index}
            className={
                inputParam_StatusKeyField !== null && inputParam_StatusKeyField !== undefined ?
                
                inputParam_StatusId > 2 && inputParam_StatusItem[inputParam_StatusKeyField] === inputParam_StatusId ?

                (inputParam_RelatedConceptComplete ?
                    
                    (
                        (inputParam_StatusId > inputParam_StatusItem[inputParam_StatusKeyField]) ? "step is-complete" :
                        (inputParam_StatusId === inputParam_StatusItem[inputParam_StatusKeyField]) ? "step is-active" :
                        (inputParam_StatusId < inputParam_StatusItem[inputParam_StatusKeyField]) ? "step" : undefined
                    )

                    :

                    "step is-incomplete"
                    
                    )

                :
                
                (
                    (inputParam_StatusId > inputParam_StatusItem[inputParam_StatusKeyField]) ? "step is-complete" :
                    (inputParam_StatusId === inputParam_StatusItem[inputParam_StatusKeyField]) ? "step is-active" :
                    (inputParam_StatusId < inputParam_StatusItem[inputParam_StatusKeyField]) ? "step" : undefined
                )
                
                
                
                : inputParam_RelatedConceptComplete ? (inputParam_StatusItem !== null && inputParam_StatusItem !== undefined ?
                    (inputParam_StatusId > inputParam_StatusItem.key) ? "step is-complete" :       
                    (inputParam_StatusId === inputParam_StatusItem.key) ? "step is-active" :
                    (inputParam_StatusId < inputParam_StatusItem.key) ? "step" : undefined        
                    :                    
                    "") : "step is-incomplete"
            }
        >
            {
                inputParam_ShowLabel && 
                <>
                    <TooltipHost
                        overflowMode={TooltipOverflowMode.Self}
                        hostClassName={css(classNames.overflow)}
                        content={
                            (inputParam_StatusValueField !== null && inputParam_StatusValueField !== undefined ?
                            t(inputParam_StatusItem[inputParam_StatusValueField])
                            : 
                            (inputParam_StatusItem !== null ? t(inputParam_StatusItem.value) : ""))
                        }
                        onTooltipToggle={false}
                        styles={{
                            root: { display: 'block', height: "30px" },
                        }}
                    >
                        <div className="d-none d-md-block">
                            {
                                (inputParam_StatusValueField !== null && inputParam_StatusValueField !== undefined ?
                                t(inputParam_StatusItem[inputParam_StatusValueField])
                                : 
                                (inputParam_StatusItem !== null ? t(inputParam_StatusItem.value) : ""))
                            }
                        </div>
                    </TooltipHost>
                    
                </>
            }
        </li>
    );
}

export default StatusItem;
